import type { CellStateTone } from '@ovComponents/4-module/widgets/portfolio/components/customAllocationCell';
import { Box, Typography } from 'hephaestus/web';

export type AccountAllocationLegendProp = {
  label: string;
  items: { label: string; tone: CellStateTone }[];
};

export const AccountAllocationLegend = ({
  label,
  items,
}: AccountAllocationLegendProp) => (
  <Box
    component='ul'
    aria-label={label}
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 3,
      listStyle: 'none',
      m: 0,
      p: 0,
    }}
  >
    {items.map(({ label, tone }) => (
      <Box
        component='li'
        key={label}
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <Box
          aria-hidden
          sx={{
            width: 14,
            height: 14,
            borderRadius: 0.5,
            border: `1.5px solid ${tone.border}`,
            backgroundColor: tone.fill,
          }}
        />
        <Typography variant='bodySmall'>{label}</Typography>
      </Box>
    ))}
  </Box>
);
